import PickupLocationTypeDropdown from "components/dropdowns/reactselect/PickupLocationTypeDropdown";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { useValidateIsNotNull } from "formvalidation/hooks";
import React from "react";

export interface PickupLocationInputValue {
  pickupLocationType: server.dto.PickupLocationType
  pickupLocationOther: string
}

interface Props {
  value: PickupLocationInputValue
  validatorKey: string
  focusOnMount?: boolean
  onChange: (value: PickupLocationInputValue, submit: boolean) => void
  submit?: () => void
  cancel?: () => void
}

export const PickupLocationInput = (props: Props) => {
  const validation = useValidateIsNotNull({
    key: props.validatorKey,
    title: RESX.GroundTransport.Pickup,
    value: props.value.pickupLocationType,
  });

  return <div className="flex-column gap-mini">
    <PickupLocationTypeDropdown
      value={props.value.pickupLocationType}
      onChange={(p: server.dto.PickupLocationType) => {
        // If the value is other, we need to provide a value
        props.onChange({ pickupLocationType: p, pickupLocationOther: "" }, p.value !== "other");
      }}
      onEsc={() => props.cancel()}
      config={{
        hasError: validation.error.hasError,
        focusOnMount: props.focusOnMount && props.value.pickupLocationType.value !== "other",
        openMenuOnFocus: props.focusOnMount && props.value.pickupLocationType.value !== "other",
      }}
    />
    {(props.value.pickupLocationType && props.value.pickupLocationType.value === "other") && <RequiredTextInput
      validatorKey={`${props.validatorKey}-other-label`}
      focusOnMount
      maxLength={serverReference.constants.groundTransport.pickupLocationOtherMaxLength}
      value={props.value.pickupLocationOther}
      onChange={(pickupLocationOther) => { props.onChange({ ...props.value, pickupLocationOther }, false); }}
      onEnter={() => props.submit?.()}
      onEsc={() => props.cancel?.()}
    />}
  </div>
}